import { render, staticRenderFns } from "./AppChip.vue?vue&type=template&id=37b3827e&scoped=true&"
import script from "./AppChip.vue?vue&type=script&lang=js&"
export * from "./AppChip.vue?vue&type=script&lang=js&"
import style0 from "./AppChip.vue?vue&type=style&index=0&id=37b3827e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b3827e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
